import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { postNewContractDataEndpoint } from '../../../common/endpoints';

export const postNewContractData = createApi(postNewContractDataEndpoint, 'POST');

const NewContract = createSlice({
  name: 'NewContract',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postNewContractData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postNewContractData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postNewContractData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default NewContract.reducer;